onQueryExecuted